export const OPENTRACK_FAILURE_REASONS = {
  // Container Trace Failures
  OPENTRACK_INTERNAL_SERVER_ERROR:
    'Error on request to Opentrack. Please retry trace',
  OPENTRACK_INTERNAL_RATE_LIMIT:
    'Hit a usage rate limit in request to Opentrack',
  CONTAINER_NOT_VALID: 'Container Number not valid',
  INVALID_SCAC_CODE: "Provided SCAC Code wasn't valid",
  MASTER_BOL_NOT_VALID: 'Master Bill of Lading not valid',
  UNEXPECTED_TRACE_ERRROR:
    'An unexpected error occured while tracing a container',
  // Container Tracking Failed
  UNTRACKABLE_CONTAINER: 'Container not found on MBL',
  // Shipmen (BOL) Tracking Failed
  UNTRACKABLE_BOL: 'Container is not found on a valid MBL',
  // Tracking Stopped Failure Events
  NO_MORE_REPORTS: 'Ocean Carrier Stopped Reporting',
  OUTDATED_SHIPMENT: 'Outdated shipment',
};

export const OPENTRACK_TRACKING_STATUS = {
  // Not an actual status sent by Opentrack
  TRACKING_INITIATED: 'tracking_initiated',
  // Actual statuses
  NOT_TRACKING: 'not_tracking',
  TRACKING: 'tracking',
  TRACKING_FAILED: 'tracking_failed',
  TRACKING_STOPPED: 'tracking_stopped',
  TRACKING_COMPLETED: 'tracking_completed'
};

export const MASTER_BOL_STATUS = {
  CONFRIMED: 'confirmed',
  NOT_FOUND: 'not_found',
  INVALID: 'invalid'
}